// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--z01uN","spinner-wrapper":"_9e1425b4d3--spinner-wrapper--mo2q8","delimiter":"_9e1425b4d3--delimiter--oAaRy"};